import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b51e93c4&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b51e93c4')) {
      api.createRecord('b51e93c4', component.options)
    } else {
      api.reload('b51e93c4', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=b51e93c4&", function () {
      api.rerender('b51e93c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/stockout/apply/detail.vue"
export default component.exports